import { mergeStyleSets, Separator, Theme } from '@fluentui/react';
import React, { createRef } from 'react'
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { callFunction } from '../lib/Helpers';
import "../styles/Settings_Help.css"
import { defaultTheme } from '../App';

type HelpProps = {
  uid: string,
  tid: string,
  sid: string,
  theme?: Theme,
  themeName?: string,
}

const Help: React.FC<HelpProps> = ({ uid, tid, sid, theme, themeName }) => {
  const appInsights = useAppInsightsContext();
  const { t } = useTranslation();
  const isDark = themeName === 'bitDarkTheme';
  const cardContainer = mergeStyleSets({
    backgroundColor: theme?.palette.neutralLighter,
    borderTop: '3px solid #FD6262',
    borderRadius: '14px',
    marginLeft: '5px',
    margingRight: '5px',
    padding: '20px 22px',
    boxShadow: isDark ? '0 18px 40px rgba(0,0,0,0.32)' : '0 16px 34px rgba(15, 23, 42, 0.08)',
  });

  const container = {
    margin: '10 5 10 0',
    width: '100%',
  }

  const refSelect = createRef<HTMLSelectElement>();
  const refText = createRef<HTMLTextAreaElement>();
  const refMessage = createRef<HTMLLabelElement>();

  const sendFeedback = (ev: React.MouseEvent<HTMLButtonElement>) => {
    if (refText.current) {
      if (refText.current.value.length > 0) {
        callFunction(true, "sendFeedback?{0}&message=" + refText.current.value + "&type=" + refSelect.current?.selectedOptions.item(0)?.value)
          .catch((error) => { if ( appInsights.isInitialized()) appInsights.trackException({ exception: error, properties: { component: 'Help', location: 'onSendFeedback' } }); });
        refText.current.value = "";
        if (refSelect.current) refSelect.current.selectedIndex = 0;
        if (refMessage.current) refMessage.current.hidden = false;
      }
    }
    ev.preventDefault();
  }

  const onTextChange = () => {
    if (refText.current && refMessage.current) refMessage.current.hidden = true;
  }

  return (
    <div id={!isMobile ? 'helpcontainer' : 'helpcontainermobile'}>
      <h3>{t('helpTitle')}</h3>
      <div id={!isMobile ? 'internalhelpcontainer' : 'internalhelpcontainermobile'}>
        <div style={container}>
          <div aria-roledescription="Support card" style={cardContainer} key="supportcard" title={t('helpTitle')}>
            <div className="help-section-title">{t('supportOverviewTitle')}</div>
            <label style={{ marginTop: '5px' }}>{t('supportOverviewText')}</label>
            <div style={{ margin: '0px 5px 0px 5px' }}><Separator theme={defaultTheme} /></div>
            <div className="help-section-title">{t('contactEmailTitle')}</div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>{t('contactEmailText')} <span><a href="mailto:support@bitfractal.com">support@bitfractal.com</a></span></label>
            </div>
            <div style={{ margin: '0px 5px 0px 5px' }}><Separator theme={defaultTheme} /></div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="help-section-title">{t('shareIdeasTitle')}</div>
              <label>{t('shareIdeasText')}</label>
            </div>
            <form className="ideasForm">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <h4 style={{marginTop: '5px'}}>{t('feedbackType')}</h4>
                <select ref={refSelect} id='feedbacktype' className="ideaoptions" name="list" >
                  <option className="ideaoptions">{t('feedbackOption')}</option>
                  <option className="ideaoptions">{t('ideasOption')}</option>
                </select>
                <h4>{t('message')}</h4>
                <textarea ref={refText} id='feedbacktext' name="message" onChange={onTextChange} style={{ width: "100%", height: "180px", fontSize: 12 }}></textarea>
              </div>
              <button className="bitbutton" onClick={sendFeedback}>{t('sendMessage')}</button>
              <label ref={refMessage} hidden={true} style={{ fontSize: 12 }} id="messagesent">{t('messageSent')}</label>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Help
